// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-actions-__id-indexstyleGrid-container-cavvd{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.pages-actions-__id-indexstyleGrid-grid-caywi{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-actions-__id-indexstyleGrid-col6-mttgg{grid-column:span 6}.pages-actions-__id-indexstyleGrid-col3-cazdg{grid-column:span 3}.pages-actions-__id-indexstyleGrid-col4-sgbyf{grid-column:span 4}.pages-actions-__id-indexstyleGrid-col9-yrmzd{grid-column:span 9}.pages-actions-__id-indexstyleGrid-col12-ylusk{grid-column:span 12}.pages-actions-__id-indexstyleGrid-alignItemsStart-briqx{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-actions-__id-indexstyleGrid-container-cavvd",
	"grid": "pages-actions-__id-indexstyleGrid-grid-caywi",
	"col6": "pages-actions-__id-indexstyleGrid-col6-mttgg",
	"col3": "pages-actions-__id-indexstyleGrid-col3-cazdg",
	"col4": "pages-actions-__id-indexstyleGrid-col4-sgbyf",
	"col9": "pages-actions-__id-indexstyleGrid-col9-yrmzd",
	"col12": "pages-actions-__id-indexstyleGrid-col12-ylusk",
	"alignItemsStart": "pages-actions-__id-indexstyleGrid-alignItemsStart-briqx"
};
module.exports = ___CSS_LOADER_EXPORT___;
